import { render, staticRenderFns } from "./redirectUrl.vue?vue&type=template&id=aaf79708&scoped=true"
import script from "./redirectUrl.vue?vue&type=script&lang=ts"
export * from "./redirectUrl.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf79708",
  null
  
)

export default component.exports